class VariantPickerCollection extends HTMLElement {
  connectedCallback() {
    this.updateCollectionTitles();
  }

  updateCollectionTitles() {
    const containers = this.querySelectorAll(".vp-variant-picker-button-collection-container");

    containers.forEach((container) => {
      const value = this.getProductTypeTitle(container);
      if (!value) return;

      const titleElement = this.findClosestCollectionTitle(container);
      if (!titleElement) return;

      const baseText = (titleElement.dataset.baseText || titleElement.textContent || "").trim();
      if (!titleElement.dataset.baseText) {
        titleElement.dataset.baseText = baseText;
      }

      titleElement.textContent = `${titleElement.dataset.baseText} ${value}`.trim();
    });
  }

  /**
   * @param {Element} container
   * @returns {string | undefined}
   */
  getProductTypeTitle(container) {
    const directChildrenWithTitle = Array.from(container.children).filter((child) =>
      child.hasAttribute("data-product-type-title"),
    );

    const activeDirectChild = directChildrenWithTitle.find((child) => child.classList.contains("active"));
    const activeDescendant = container.querySelector(".active[data-product-type-title]");
    // const firstDirectChild = directChildrenWithTitle[0];
    // const firstDescendant = container.querySelector("[data-product-type-title]");

    // const sourceElement = activeDirectChild || activeDescendant || firstDirectChild || firstDescendant;

    const sourceElement = activeDirectChild || activeDescendant;
    return sourceElement?.getAttribute("data-product-type-title")?.trim();
  }

  /**
   * @param {Element} container
   * @returns {HTMLElement | null}
   */
  findClosestCollectionTitle(container) {
    let sibling = container.previousElementSibling;

    while (sibling) {
      if (sibling.classList.contains("vp-variant-picker-collection-title")) {
        return /** @type {HTMLElement} */ (sibling);
      }
      sibling = sibling.previousElementSibling;
    }

    return null;
  }
}

if (!customElements.get("variant-picker-collection")) {
  customElements.define("variant-picker-collection", VariantPickerCollection);
}
